import { css, withStyles } from '@recruit-robin/robin-theme/web-styles';

export const useStyles = withStyles({
  dialog: () => css`
    width: 100vw;
    height: 100vh;
    max-width: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
  `,
  loader: () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 200px;
    width: 100%;
  `,
  title: () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  `,
});
